type InsertedPanelNavigation = {
    getIndex: (panelId: string) => number
    insertionPending: (panelId: string) => boolean
    subscribe: (listener: () => void) => () => void
    scheduleFrame: (callback: () => void) => unknown
    slide: (index: number) => unknown
}

// Desktop inserts can be staged until their shift animation finishes. Follow
// the new panel's identity, then let React/Swiper render it before navigating.
export function slideToInsertedPanel(panelId: string, navigation: InsertedPanelNavigation) {
    let unsubscribe: (() => void) | undefined
    const check = () => {
        if (navigation.getIndex(panelId) < 0) {
            if (!navigation.insertionPending(panelId)) unsubscribe?.()
            return
        }
        unsubscribe?.()
        navigation.scheduleFrame(() => {
            const index = navigation.getIndex(panelId)
            if (index >= 0) navigation.slide(index)
        })
    }
    if (navigation.getIndex(panelId) < 0 && navigation.insertionPending(panelId)) {
        unsubscribe = navigation.subscribe(check)
    }
    check()
}
